import gql from 'graphql-tag';

export const PRICING_POLICY_CREATE_MUTATION = gql`
	mutation CreatePricingPolicy($input: CreatePricingPolicyInput!) {
		createPricingPolicy(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const PRICING_POLICY_UPDATE_MUTATION = gql`
	mutation UpdatePricingPolicy($input: UpdatePricingPolicyInput!) {
		updatePricingPolicy(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;
